import { tv } from 'tailwind-variants';

const styles = tv({
  base: `
    flex
    h-96
    flex-[0_0_100%]
    items-center
    justify-center

    [&_img]:max-h-full
    [&_picture]:flex
    [&_picture]:h-full
    [&_picture]:items-center
    [&_picture]:justify-center
  `,
  slots: {
    youtubePlayer: `
      h-full

      [&_iframe]:h-[344px]
      [&_iframe]:max-w-full
    `,
  },
});

export default styles;
